import * as Constants from "../utils/constants";

export const getActivitySessionEventsourceConnection = (oid: any) => {
  return new EventSource(
    Constants.ApiBasePath + "/sessions/" + oid + "/notifications"
  );
};
